// extracted by mini-css-extract-plugin
module.exports = {"Popover":"Popover_Popover__VejX1","TriggerWrapper":"Popover_TriggerWrapper__4dYMA","PopoverContainer":"Popover_PopoverContainer__I7DNs","menu":"Popover_menu__F52BV"};